import React, { useState, useRef, useEffect } from 'react';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import styles from './Counter.module.css';

import Box from '@mui/material/Box';

import {fromLonLat} from 'ol/proj';
import {Circle, Style, Fill, Stroke} from 'ol/style';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import XYZ from 'ol/source/XYZ'
import View from 'ol/View';
import Point from 'ol/geom/Point';

//import { Camera } from './mapSlice';


/*
function camerasToFeatures(cameras: Camera[]): Feature[] {
        let ret: Feature[] = new Array();
        return ret;
}
// */

// https://openlayers.org/en/latest/apidoc/module-ol_Map-Map.html
// https://taylor.callsen.me/using-openlayers-with-react-functional-components/
export function MapWrapper(props: any) {
	const dispatch = useAppDispatch();
	const [ map, setMap ] = useState<Map>()
	const [ featuresLayer, setFeaturesLayer ] = useState<VectorLayer<VectorSource>>()
	const [ selectedCoord , setSelectedCoord ] = useState()
	const first = useRef(true);

	const sxOut= {
		width: '100%',
		height: '100%',
		backgroundColor: 'red',
		margin: 0,
	};
	const sxIn= {
		width: '100%',
		height: '100%',
		margin: 0,
	};
	// get ref to div element - OpenLayers will render into this div
	//const mapElement = useRef<HTMLDivElement>(null)
	//console.log('mapElement', mapElement);
	//const mapElementTarget: HTMLElement = mapElement ? mapElement : undefined;
	// initialize map on first render - logic formerly put into componentDidMount
	useEffect(() => {
		if (!first.current)
			return;
		first.current = false;
		console.log('useEffect is executed');
		//let coord = [43.5313838, 4.7487552];
		let coord = [5.4683230, 43.3595320];
		let marker = new Point(fromLonLat(coord));
		let pointFeature = new Feature({
			geometry: marker,
			//initalFeaturesLayer,
		});

		// create and add vector source layer
		const initalFeaturesLayer = new VectorLayer({
			source: new VectorSource({
				features: [pointFeature],
			}),
			minZoom: 10,
			//*
			style: new Style({
				image: new Circle({
					fill: new Fill({color: 'rgba(255,255,255,0.4)'}),
					stroke: new Stroke({color: 'red'}),
					radius: 5
				}),
				fill: new Fill({color: 'red'}),
				stroke: new Stroke({color: 'red'}),
			}),
			// */
		})
		// create map
		const initialMap = new Map({
			//target: mapElement.current,
			target: 'mapElement',
			layers: [

				// USGS Topo
				new TileLayer({
					source: new OSM()
					//source: new XYZ({
					//      url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}',
					//})
				}),

				initalFeaturesLayer

			],
			view: new View({
				projection: 'EPSG:3857',
				center: [0, 0],
				zoom: 2
			}),
			controls: []
			// z
		})

		// save map and vector layer references to state
		setMap(initialMap)
		setFeaturesLayer(initalFeaturesLayer)
		console.log('end of useEffect');

	},[])

	return (
		<Box sx={sxOut}>
			<Box sx={{height: '100%'}}>
				<Box id="mapElement" sx={sxIn}>
				</Box>
			</Box>
		</Box>
	);
}

